import { render, staticRenderFns } from "./MoqMessageComponent.html?vue&type=template&id=a9fe409c&scoped=true&"
import script from "./MoqMessageComponent.js?vue&type=script&lang=js&"
export * from "./MoqMessageComponent.js?vue&type=script&lang=js&"
import style0 from "./MoqMessageComponent.scss?vue&type=style&index=0&id=a9fe409c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fe409c",
  null
  
)

export default component.exports